import { getSaveableDateWithTime } from "../utils/DateHelper";
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from '../utils/ReduxHelper';
import Layer from "@arcgis/core/layers/Layer";
import store from "../redux/store";
import FieldNames from '../defaults/FieldNames.json'

const ErrorService = {
  errorLayer: null,
  addErrorLogEntry: function (errorEntry = "", nifcUserNameOverride = null) {
    // NOTE: addErrorLogEntry is called several hundred times in codebase. Only a small fraction do NOT read from the
    // current user logged in. The override allows for cleaner calling points and reduction of userInfo being accessed
    // in calling point file.
    const currentUserNifcUserName = nifcUserNameOverride ?? store.getState().globalContext.userInfo?.[FieldNames.userFields.nifcUsername] ?? 'UNKNOWN'

    const rootServiceUrl = getAttributeServiceUrl();
    const config = getAppConfig();
    const nifcToken = getNifcToken();
    this.addErrorLogCall(currentUserNifcUserName, rootServiceUrl, config, nifcToken, errorEntry);
  },

  addErrorLogEntryFromRedux: function (nifcUserName, state, errorEntry = "") {
    const rootServiceUrl = state?.rootServiceUrl;
    const config = state?.config;
    const nifcToken = state?.nifcToken;
    this.addErrorLogCall(nifcUserName, rootServiceUrl, config, nifcToken, errorEntry);
  },

  setErrorLayer: async function(config){
    return await Layer.fromPortalItem({id: config.errorLog[config.env].portalItem.id})
  },

  callGetSaveableDateWithTime: function() {
    return getSaveableDateWithTime()
  },

  addErrorLogCall: async function (nifcUserName, rootServiceUrl, config, nifcToken, errorEntry = "") {
    let errorObj = {};
    let specificsExist = false;
    if (!config){
      return
    }

    if(errorEntry )
    {
      if(errorEntry.details)
      {
        specificsExist = true;
        if(Array.isArray(errorEntry.details))
        {
          errorObj.details = errorEntry.details;
        }
        else
        {
          let detailObj = {};
          if(errorEntry.details.messages)
          {
            detailObj.messages = errorEntry.details.messages;
          }
          if(errorEntry.details.httpStatus)
          {
            detailObj.httpStatus = errorEntry.details.httpStatus;
          }
          if(errorEntry.details.url)
          {
            detailObj.url = errorEntry.details.url;
          }
          if(errorEntry.details.requestOptions && errorEntry.details.requestOptions.query)
          {
            detailObj.query = errorEntry.details.requestOptions.query;
          }
          errorObj.details = detailObj;
        }
      }
      if(errorEntry.message)
      {
        specificsExist = true;
        errorObj.message = errorEntry.message;
      }
      if(errorEntry.name)
      {
        errorObj.name = errorEntry.name;
      }
      if(errorEntry.code)
      {
        errorObj.code = errorEntry.code;
      }

      if(!specificsExist)
      {
        errorObj.message = errorEntry;
      }
    }
    else
    {
      errorObj.message = errorEntry;
    }

    if(config?.env !== "prod")
    {
      console.log(errorObj);
    }

    const errorLogEntry = {
      Username : nifcUserName ?? "UNKNOWN",
      ErrorTime : this.callGetSaveableDateWithTime(),
      ErrorLog : JSON.stringify(errorObj)
    }
    const newErrorLogEntry = 
    {
        attributes: errorLogEntry
    }
    if (!this.errorLayer){
      this.errorLayer = await this.setErrorLayer(config);
    }

    this.errorLayer.applyEdits({addFeatures: [newErrorLogEntry]}).catch( error => {
            console.error(error);
    });
  },
};



export default ErrorService;